import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { subscriptionPlansUrl, subscriptionsUrl } from 'src/app/auth/utility/auth.urls';
import { HttpClientWrapper } from 'src/app/http-client-wrapper';
import { ListDTO, PaginationConfig } from '../../loading-state/api.models';
import {
  SubscriptionDTO,
  SubscriptionPlanDTO,
  SubscriptionPlanFilters,
} from '../subscription.models';

@Injectable({ providedIn: 'root' })
export class SubscriptionDataService {
  constructor(private wrapper: HttpClientWrapper) {}

  public getSubscriptionPlans(
    filters?: SubscriptionPlanFilters,
    pagination?: PaginationConfig
  ): Observable<ListDTO<SubscriptionPlanDTO>> {
    return this.wrapper.get<ListDTO<SubscriptionPlanDTO>>(subscriptionPlansUrl, {
      ...filters,
      ...pagination,
    });
  }

  public getSubscription(): Observable<SubscriptionDTO> {
    return this.wrapper.get<SubscriptionDTO>(subscriptionsUrl);
  }
}
